import React, { Component } from 'react';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import { connect } from 'react-redux';
import { setTableData } from '../../action/index';
import { bindActionCreators } from 'redux';

class LogComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            logData: null,
            summary:null,
            headerLabel:{
                "updated_time": "Updated Time",
                "fileName": "File Name",
                "size": "File Size",
                // "total_cols": "Total Columns",
                "new_inserted_rows": "Total Rows",
                // "action": "Action",
                // "isProcessed":"Process Status",
                "summary": "Summary",
                // "updated_by": "Updated By",
            }        
        };

        this.fetchLogData = this.fetchLogData.bind(this);
        this.generateTableHeaders = this.generateTableHeaders.bind(this);
        this.generateTableRows = this.generateTableRows.bind(this);
        this.formatLogData = this.formatLogData.bind(this);
        this.controlPanel = this.controlPanel.bind(this);
        this.calculateFileSize = this.calculateFileSize.bind(this);
        this.formatSummaryData = this.formatSummaryData.bind(this);
        this.orderColumns = this.orderColumns.bind(this);
    }

    componentWillMount() {
        this.fetchLogData();
    }

    componentDidUpdate(prevProps,prevState){
        // if(prevState.summary == this.state.summary){
        const that = this;
        let tableCheck = jQuery.fn.DataTable.isDataTable('#logTable');
        if(!tableCheck){
            jQuery('#logTable').DataTable({
                responsive: true,
                orderClasses: false,
                autoWidth: false,
                language: {
                    searchPlaceholder: 'Search...',
                    sSearch: '',
                    lengthMenu: '_MENU_ items/page',
                },
                columnDefs: [
                    { "className": "dt-center", "targets": "_all" }
                ],
                // colReorder: true

                colReorder: {
                    // order: [4,1,0,2,3]
                    order: that.orderColumns()
                    // order: [3,0,1,2]
                }
            }); 
        }
        jQuery('#summaryTable').DataTable({
            responsive: true,
            paging: false,
            orderClasses: false,
            autoWidth: false,
            language: {
                searchPlaceholder: 'Search...',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
            },
            columnDefs: [
                { "className": "dt-center", "targets": "_all" }
            ],
            // colReorder: true

            colReorder: {
                order: [3, 0, 1, 4, 2]
                // order: [3,0,1,2]
            }
        }); 
        // }
          
    }

    orderColumns() {
        const headerLabel = this.state.headerLabel;
        const logData = this.state.logData;
        let order = [];
        if (logData !== null) {
            if(logData.length !== 0){
                var responseHeaders = Object.keys(logData[0]).filter((item, x) => {
                    if (headerLabel[item] !== null && headerLabel[item] !== undefined) {
                        return item;
                    }
                });
                order = Object.keys(headerLabel).map((element, i) => {
                    let index = responseHeaders.indexOf(element);
                    return index;
                });
            }
          
        }
        return order;
    }

    fetchLogData() {
        this.setState({
            logData: null
        })

        let that = this;

        let searchParams = new URLSearchParams(location.search);

        let params = {
            siteId: localStorage.Cookies ? JSON.parse(localStorage.Cookies).siteId : null,
            tableName: searchParams.get("tableName"),
            email: localStorage.Cookies ? JSON.parse(localStorage.Cookies).username : null,

        }
       
        CallAPI('GET', '/app/getUploadedFiles', null, params, 0, function (response) {
            let informationData = null;
            if(response.status){
                if(response.information.length !== 0){
                    informationData = response.information;
                    that.setState({
                        logData: informationData,
                    });
                }
            }
            else{
                that.setState({
                    logData: []
                });
            }
        },this.props.authData)
    }


    componentDidMount() {
        // jQuery(".custom-file-input").on("change", function () {
        //     var fileName = jQuery(this).val().split("\\").pop();
        //     jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        // });

    }

    generateTableHeaders(flag = 'log'){
        try{
            let that = this;
            var headerLabel = this.state.headerLabel;
            let tableHeaders = [];

            let currentDataState = this.state.logData;
            let headerKeys = Object.keys(currentDataState[0]);

            if(flag == "summary"){
                headerKeys = ["Column Name","Value"]
            }


            for (let index = 0; index < headerKeys.length; index++) {
                if(flag == 'log'){
                    let key = headerKeys[index];
                    if (headerLabel[key] !== null && headerLabel[key] !== undefined) {
                        tableHeaders.push(<th key={`${key}_${index}_header`} scope="col">{headerLabel[key]}</th>);
                    }
                }
                else if(flag =='summary'){

                    tableHeaders.push(<th style={{ "textAlign": "center"}} key={`${index}_header`} scope="col">{headerKeys[index]}</th>);
                }
                
            }

            return tableHeaders;
        }
        catch(e){
            return "error";
        }
       
    }

    controlPanel(index,e){
        e.preventDefault();
        let summary = null;
        let defaultClass = "off-canvas off-canvas-push off-canvas-right wd-500";
        let openClass = defaultClass + ' show';
        if(index !== null){
            jQuery("#summaryPane").removeClass(defaultClass);

            jQuery("#summaryPane").addClass(openClass);
            // let summaryValue = this.state.logData[index]['summary'];
            let summaryValue = this.state.logData[index];
            // if (summaryValue !== null && summaryValue !== undefined){
            //     summary = JSON.parse(this.state.logData[index]['summary']);
            // }
            this.setState({
                summary: summaryValue
            })
        }
        
        if (index == null && e.target.id == "closeButton"){
            jQuery("#summaryPane").removeClass(openClass);

            jQuery("#summaryPane").addClass(defaultClass);
            this.setState({
                summary: summary
            })
        }
    }

    calculateFileSize(number,format = "kb"){
        let sizeFormat = ["b","kb","mb","gb"];
        let divisionRounds = 0;
        let quotient = 0;
        let divisor = 1024;
        let final_value = '';
        number = Number(number);

        format = (this.state.logData[0].file_size_unit !== null && this.state.logData[0].file_size_unit !== undefined) ? this.state.logData[0].file_size_unit :format.toLowerCase();

        if(sizeFormat.indexOf(format !== -1)){
            switch (format) {
                case 'kb':
                    divisionRounds = 1;
                    break;
                case 'mb':
                    divisionRounds = 2;
                    break;
                case 'gb':
                    divisionRounds = 3;
                    break;
                default:
                    break;
            }
        }
        if( number !== 0){
            for (let index = 0; index < divisionRounds; index++) {
                quotient = number/divisor;
                number = quotient;
            }

            number = number.toFixed(2);
            final_value = `${number.toString()} ${format.toUpperCase()}`;

        }
        else if(number == 0){
            final_value = `${number.toString()} ${format}`;
        }
        else if(number == null){
            final_value = `File size not available`;
        }

        return final_value;

        
    }

    formatLogData(key,logObj,index){
        let final_value = {
            "value":null,
            "search":null,
            "sort":null,
            style:{
            }
        };
        if (key == "updated_time") {
            final_value.value = `${moment(logObj[key]).format('MMMM Do YYYY')}@${moment(logObj[key]).format('H:mm:ss')}`;
            final_value.search = logObj[key];
            final_value.sort = logObj[key];
        }
        else if (key == "new_inserted_rows"){
            final_value.value = logObj[key];
            final_value.style.textAlign = "right";
            final_value.search = Number(logObj[key]);
            final_value.sort = Number(logObj[key]);
        }
        else if(key == "fileName"){
            let color = '';
            if(logObj['isProcessed'] == "1"){
                color = "#90ee90";
            }
            else if (logObj['isProcessed'] == "0"){
                color = "#ffcccb";
            }
            // final_value.value = logObj[key];
            final_value.value = (<div>
                {logObj[key]}
                <div>
                    <span className="tx-11">{`Total Columns:${logObj['total_cols']}`}</span>
                </div>
            </div>);
            final_value.style.backgroundColor = color;

        }
        else if( key =="size"){
            final_value.value = `${Number(logObj[key]).toFixed(2)} ${logObj['file_size_unit'].toUpperCase()}`;
            final_value.style.textAlign = "right";
            final_value.search = Number(logObj[key]);
            final_value.sort = Number(logObj[key]);

        }
        else if (key == "isProcessed"){
            if (logObj[key] == "0"){
                final_value.value = "No";
            }
            else if (logObj[key] == "1"){
                final_value.value = "Yes";
            }
        }
        else if (key == "summary") {
            let summary = JSON.parse(logObj[key]);
            if (summary !== null && summary !== undefined) {
                let summaryKeys = Object.keys(summary);
                let list_elements = '';
                for (let i = 0; i <= 1; i++) {
                    let numberValue = summary[summaryKeys[i]];
                    if(numberValue !== undefined && numberValue !== null){
                        // if (numberValue.indexOf(".") !== -1) {
                            numberValue = Number(numberValue).toFixed(2);
                        // }
                        list_elements += `${summaryKeys[i]}:${numberValue}, `;
                    }
                    else{
                        numberValue = '-';
                    }
                }
                list_elements = list_elements.replace(/,\s*$/, "");

                logObj['summaryDiv'] = (<div>
                    <div>{list_elements}</div>
                    <div><a id={`pane_${index}`} style={{ cursor: "pointer" }} href="javascript:void(0)" onClick={this.controlPanel.bind('index', index)}>View More</a></div>
                </div>);
                final_value.value = logObj['summaryDiv'];

            }
        }
        else if(key == "action"){
            final_value.value = `${logObj[key].charAt(0).toUpperCase()}${logObj[key].slice(1)}`;
        }
        else {
            final_value.value = logObj[key];
        }

        return final_value;
    }

    formatSummaryData(){
        let summary = this.state.summary['summary'];
        let summaryArray = [];
        if (summary !== null && summary !== undefined){
            let summaryObj = JSON.parse(this.state.summary['summary']);
            for (const key in summaryObj) {
                if (summaryObj.hasOwnProperty(key)) {
                    let innerArray = {};
                    let numberValue = '';
                    if (summaryObj[key] !== null){
                        numberValue = summaryObj[key].toString();
                        // if (numberValue.indexOf(".") !== -1) {
                            numberValue = Number(numberValue).toFixed(2);
                        // }
                    }
                    else{
                        numberValue = '-';
                    }
                  
                    innerArray['columnName'] = key;
                    // innerArray['value'] = summaryObj[key];
                    innerArray['value'] = numberValue;
                    summaryArray.push(innerArray);
                }
            }
        }
        return summaryArray;
    }

    generateTableRows(flag='log'){
        let that = this;
        let currentDataState = this.state.logData;
        if(flag == 'summary'){
            currentDataState = this.formatSummaryData();
        }
        let headerLabel = this.state.headerLabel;
        var tableBody = currentDataState.map((element, i) => {
            let keyElements = Object.keys(element);
            let table_rows = [];

            for (let index = 0; index < keyElements.length; index++) {
                let inner = keyElements[index];
                if(flag == 'log'){
                    if (headerLabel[inner]) {
                        let final_value = that.formatLogData(inner, element, i);
                        table_rows.push(<td data-search={final_value.search} data-sort={final_value.sort} style={final_value.style} key={`${inner}_${i}_${index}_cell`}>{final_value.value}</td>);
                    }
                }
                else if(flag == 'summary'){
                    let style = {};
                    if(inner == "value"){
                        style.textAlign = "right";
                    }
                
                    table_rows.push(<td style={style} key={`${inner}_${i}_${index}_cell`}>{element[inner]}</td>);
                }
              
            }
            return (<tr key={`row_${i}`}>{table_rows}</tr>);
        });
        return tableBody;
    }




    render() {

        let that = this;
        var mainData = <LoadingComponent />;
        var summaryBody = null;
        var summaryData = this.state.summary;
        if (this.state.logData) {
            
            let tableHeaders = this.generateTableHeaders();
            if(tableHeaders !== "error"){
                let tableBody = this.generateTableRows();
                mainData = (<table id="logTable" className="table table-bordered">
                    <thead className="thead">
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {tableBody}
                    </tbody>
                </table>)

                if (summaryData !== null) {
                    let summaryHeaders = this.generateTableHeaders('summary');
                    let summaryRows = this.generateTableRows('summary');
                    summaryBody = (<div>
                        <div className="mg-y-5 tx-medium">
                            {`Selected File: ${this.state.summary.fileName}`}
                        </div>
                        <div style={{"overflowY":"scroll","height":"500px"}}>
                            <table id="summaryTable" className="table table-bordered">
                                <thead className="thead">
                                    <tr>
                                        {summaryHeaders}
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryRows}
                                </tbody>
                            </table>
                        </div>
                        </div>)

                    // let summaryMetricList = summaryKeys.map((element, i) => {
                    //     return (<li className="list-group-item">{`${element}:${summaryData[element]}`}</li>);
                    // });
                    // summaryBody = (<ul className="list-group">
                    //     {summaryMetricList}
                    // </ul>);
                }
            }
            else{
                mainData = <div id="errorDiv" className='d-flex flex-column align-items-center justify-content-center mg-t-100'>
                    <div className="align-self-center">
                        <span className="tx-16 tx-medium">{"No Logs were found for the table"}</span>
                    </div>
                </div>;
            }
        }
        else{
            mainData = <LoadingComponent />;;
        }
        // else {
        //     mainData = <LoadingComponent />;
        // }

        return (
            <div className="col-md-12">              
                {mainData}
                <div id="summaryPane" className="off-canvas off-canvas-push off-canvas-right wd-500">
                    {/* <a id="" href="#" className="close">close</a> */}
                    <div className="pd-25 ht-100p tx-13">
                        <div className='card-header tx-16 pd-10'>
                            {"File Summary"}
                            <a id="closeButton" className="close float-right" style={{ cursor: "pointer" }} href="javascript:void(0)" onClick={this.controlPanel.bind('index', null)}>x</a>
                        </div>
                        {summaryBody}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {        
        authData: state.dataSet.authData
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTableData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LogComponent);
